module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('box', {
    attrs: {
      "title": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('h4', [_vm._v("Escolha o tipo de relatório:")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipoRelatorio),
      expression: "tipoRelatorio"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "exampleFormControlSelect1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tipoRelatorio = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "regiao"
    }
  }, [_vm._v("Por região (bairro)")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', {
    staticClass: "text-center",
    staticStyle: {
      "font-size": "17px"
    }
  }, [_c('strong', [_vm._v("Bairros")]), _c('br'), _vm._v("\n              As regiões onde mais efetuam pedidos\n            ")]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "regioesPreferidas"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-borde#F48668 table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.colunas), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.orderPedidos(coluna.json)
        }
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-7"
    }, [_vm._v("\n                                " + _vm._s(_vm._f("ucwords")(coluna)) + "\n                              ")])])])])
  }), 0)]), _vm._v(" "), _c('tbody', [(_vm.enderecos.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("Nenhum Pedido Localizado")])]) : _vm._l((_vm.enderecos), function(p, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(_vm._f("upperCase")(p.bairro)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.qtde))])])
  })], 2), _vm._v(" "), _c('tfoot')])])])])])])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66a2c6dd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Pedidos/Relatorios.vue
// module id = 1260
// module chunks = 1